import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { FormsService } from "../../services/FormService";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { FormsData } from "../../models/FormsData";
import { Http } from "@status/codes";
import {
  FORMS_ACCESS,
  FORMS_CONSTANTS,
  PROFILE_ROUTE
} from "../../constants/FormsConstants";
import { Forms } from "../../models/Forms";
import { QuerySearch } from "../../models/QuerySearch";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import {
  FORM_TEMPLATES_ACCESS,
  FORM_TEMP_CONSTANTS
} from "@/modules/FormTemplate/constants/FormTemplateConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FormSchema } from "@/shared/models/FormSchema";
import FormRulePreview from "@/shared/components/FormModalViewer/FormRulePreview/FormRulePreview.vue";
import FormSummaryPreview from "@/shared/components/FormModalViewer/FormSummaryPreview/FormSummaryPreview.vue";
import vueDebounce from "vue-debounce";
import { TASK_CONSTANTS } from "@/modules/Tasks/constants/TaskConstants";
import { Utils } from "@/shared/utils/utils";
import { AxiosError } from "axios";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import {
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";

Vue.use(vueDebounce, {
  defaultTime: "2000ms",
  listenTo: ["input", "click"]
});

@Component({
  name: "FormCards",
  components: {
    ModifVJsfInput,
    FormRulePreview,
    FormSummaryPreview
  }
})
export default class FormCards extends Vue {
  dataToLateralMenu!: MenuDataStructure;
  @Prop() header!: FormsData;
  @Prop() medicalOrder!: MedicalOrderPreviewEventTimelineModel;
  @Prop() showEdit!: boolean;
  @Inject() formsService!: FormsService;
  @Inject() formTemplateService!: FormTemplateService;

  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  refresh = 0;
  modelChanged = false;
  dialog = false;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  model: any = {};
  formData!: FormsData;
  dataForm = false;
  showSave = true;
  partialSave = false;
  saveChanges = false;
  formulaValue = "";
  formRules: FormRule[] = [];
  formSummary: FieldSummary[] = [];
  textfieldValidation = false;

  SAVE_CHANGES_TEXT = FORMS_CONSTANTS.BUTTON.SAVE_FORM;
  DELETE_TASK_BTN = FORMS_CONSTANTS.BUTTON.DELETE_TASK;
  RESPONSABLE_TASK_BTN = FORMS_CONSTANTS.BUTTON.RESPONSABLE_TASK;
  CATEGORY_TEXT = FORMS_CONSTANTS.TEXT.CATEGORY;
  TYPE_TEXT = FORMS_CONSTANTS.TEXT.TYPE;
  SEND_UPDATE_BTN = FORMS_CONSTANTS.BUTTON.SEND_FORM;
  TITLE = this.header.formTemplate.name;
  RESPONSABLE?: { id: string; name: string }[] = [{ id: "", name: "" }];
  CATEGORY = this.header.formTemplate.category;
  ROLE = this.header.formTemplate.taskId;
  STATUS_TEXT = "";

  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  selectedBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;

  mounted() {
    if (this.header.form) {
      this.STATUS_TEXT = this.header.form.status;
      this.selectedBtnClass = STYLE_CLASSES.PRIMARY_BTN;

      if (this.header.form.status == FORMS_CONSTANTS.STATE.COMPLETE) {
        this.showSave = false;
        this.SEND_UPDATE_BTN = FORMS_CONSTANTS.BUTTON.UPDATE_FORM;
      } else {
        this.saveChanges = true;
      }
    } else {
      this.STATUS_TEXT = FORMS_CONSTANTS.PENDING_TEXT;
    }
    if (this.header.related) {
      this.RESPONSABLE = this.header.related;
    }
    if (this.showEdit) {
      this.dialog = true;
      this.openForm();
    }
  }

  checkModel() {
    let modelSize = 0;
    const newFields: any = {};

    for (const property in this.model) {
      if (this.model[property].length !== 0) {
        const fieldValue = this.formData.formTemplate.fields.find(
          item => item.key === property
        );

        newFields[property] = {
          indicator: fieldValue?.indicator,
          title: fieldValue?.schema[property].title
        };

        if (
          fieldValue?.type === FORMS_CONSTANTS.FIELD_TYPE.LIST ||
          fieldValue?.visualElement === FORMS_CONSTANTS.FIELD.CHECKBOX
        ) {
          const fieldOptions = fieldValue?.options;

          switch (fieldValue?.visualElement) {
            case FORMS_CONSTANTS.FIELD.RADIO: {
              const listOption = fieldOptions?.find(
                item => item.value === this.model[property]
              );

              newFields[property].titleSelectValue = [
                {
                  title: listOption?.title,
                  value: listOption?.value,
                  type: FORMS_CONSTANTS.FIELD.RADIO
                }
              ];
              newFields[property].scoreSelectValue = listOption?.score;
              newFields[property].value = [listOption?.value];
              newFields[property].listTemplate = fieldValue?.list;

              break;
            }
            case FORMS_CONSTANTS.FIELD.CHECKBOX: {
              const selectedValues = [];
              const titleItems = [];

              if (fieldValue?.type == FORMS_CONSTANTS.FIELD_TYPE.BASIC) {
                for (const checkItem in this.model[property]) {
                  selectedValues.push(this.model[property][checkItem]);
                }
                newFields[property].value = selectedValues;
              } else {
                for (const checkItem in this.model[property]) {
                  const listOption = fieldOptions?.find(
                    item => item.value === this.model[property][checkItem]
                  );
                  selectedValues.push(listOption?.value);
                  titleItems.push({
                    title: listOption?.title,
                    value: listOption?.value,
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });

                  newFields[property].scoreSelectValue = listOption?.score;
                  newFields[property].titleSelectValue = titleItems;
                  newFields[property].value = selectedValues;
                }
                newFields[property].listTemplate = fieldValue?.list;

                if (this.model[property].length > 1)
                  newFields[property].scoreSelectValue = null;
              }
              break;
            }
            case FORMS_CONSTANTS.FIELD.SELECT: {
              if (Array.isArray(this.model[property])) {
                newFields[property].titleSelectValue = [];
                newFields[property].value = [];
                for (const selected of this.model[property]) {
                  const listOption = fieldOptions?.find(
                    item => item.value === selected
                  );
                  const listTitle = fieldValue?.schema[property].oneOf?.find(
                    item => item.const === selected
                  );
                  newFields[property].titleSelectValue.push({
                    title: listTitle?.title,
                    value: listOption?.value,
                    type: FORMS_CONSTANTS.FIELD.SELECT
                  });
                  newFields[property].value.push(listOption?.value);
                }
              } else {
                const listOption = fieldOptions?.find(
                  item => item.value === this.model[property]
                );
                const listTitle = fieldValue?.schema[property].oneOf?.find(
                  item => item.const === this.model[property]
                );
                newFields[property].titleSelectValue = [
                  {
                    title: listTitle?.title,
                    value: listOption?.value,
                    type: FORMS_CONSTANTS.FIELD.SELECT
                  }
                ];
                newFields[property].scoreSelectValue = listOption?.score;
                newFields[property].value = [listOption?.value];
              }
              newFields[property].listTemplate = fieldValue?.list;
              break;
            }
          }
        } else {
          if (Array.isArray(this.model[property]))
            newFields[property].value = this.model[property];
          else newFields[property].value = [this.model[property]];
        }
        modelSize += 1;
      }
    }
    return { modelSize, newFields };
  }

  async onSend(state: string) {
    if (this.dataForm) {
      this.dialog = false;

      const modelChecked = this.checkModel();
      const newFields = modelChecked.newFields;
      const modelSize = modelChecked.modelSize;

      const form: Forms = {
        name: this.formData.formTemplate.name,
        category: this.formData.formTemplate.category,
        fields: newFields,
        formTemplate: this.formData.formTemplate.id,
        versionTemplate: this.formData.formTemplate.version,
        owner: this.formData.formTemplate.user,
        status: state
      };

      try {
        if (modelSize !== 0) {
          const addResponse = await this.formsService.adduserForm(
            this.header.formTemplate.taskId,
            form
          );

          if (addResponse.code === Http.Ok) {
            this.STATUS_TEXT = state;
            this.selectedBtnClass = STYLE_CLASSES.PRIMARY_BTN;

            if (state === FORMS_CONSTANTS.STATE.INCOMPLETE) {
              this.saveChanges = true;
            } else {
              this.SEND_UPDATE_BTN = FORMS_CONSTANTS.BUTTON.UPDATE_FORM;
              this.showSave = false;
              this.completeState();
            }
          }

          Snackbar.popInfo(addResponse.message);
        }
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(
            FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.POST
          );
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } else {
      Snackbar.popWarning(FORMS_CONSTANTS.SNACKBAR_MSG.EMPTY_FIELDS);
    }
  }

  async openForm() {
    await this.getFormTemplatePreviewData(this.header.formTemplate.id);

    const loadData =
      this.STATUS_TEXT === FORMS_CONSTANTS.PENDING_TEXT ? false : true;

    const query: QuerySearch = {
      taskId: this.header.formTemplate.taskId,
      formTemplateId: this.header.formTemplate.id,
      loadData: loadData
    };

    if (loadData === true) {
      query.versionTemplate = this.header.form
        ? this.header.form.versionTemplate
        : this.formData.formTemplate.version;
    }

    try {
      const form = await this.formsService.formInformation(query);

      if (form.code == Http.Found && form.data) {
        this.formData = form.data;

        if (this.formData.form) {
          this.model = Object.assign({}, this.formData.form.fields);
          this.refresh = 1 - this.refresh;
        }
      } else {
        this.dialog = false;
        Snackbar.popError(FORMS_CONSTANTS.SNACKBAR_MSG.ERROR_LOAD);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }

    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
      type: PANEL_INFO_CONSTANTS.TYPE.TASK,
      action: PANEL_INFO_CONSTANTS.ACTION.HIDE
    });
  }

  async onUpdate(state?: string) {
    if (this.dataForm) {
      const modelChecked = this.checkModel();
      const newFields = modelChecked.newFields;
      const form: Forms = { ...this.formData.form };

      this.dialog = false;
      form.name = this.formData.formTemplate.name;
      form.category = this.formData.formTemplate.category;
      form.fields = newFields;
      form.versionTemplate = this.formData.formTemplate.version;
      form.formTemplate = this.header.formTemplate.id;

      if (
        this.formData.form.status == FORMS_CONSTANTS.STATE.INCOMPLETE &&
        state !== undefined
      ) {
        form.status = state;
        this.STATUS_TEXT = state;

        if (state == FORMS_CONSTANTS.STATE.COMPLETE) {
          this.saveChanges = false;
          this.showSave = false;
          this.SEND_UPDATE_BTN = FORMS_CONSTANTS.BUTTON.UPDATE_FORM;
        }
      }
      try {
        const response = await this.formsService.updateForm(
          this.formData.formId,
          this.header.formTemplate.taskId,
          form
        );

        if (state == FORMS_CONSTANTS.STATE.COMPLETE) this.completeState();

        Snackbar.popInfo(response.message);
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.PUT);
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } else {
      Snackbar.popWarning(FORMS_CONSTANTS.SNACKBAR_MSG.EMPTY_FIELDS);
    }
  }

  async saveFormChanges() {
    // TODO: Se comenta, porque resetea los campos multiselect del vjsf al hacer el reload. Validar en caso de fallas
    // const formHasBeenReloaded = await this.reloadData();
    // if (formHasBeenReloaded) {
    await this.onSend(FORMS_CONSTANTS.STATE.INCOMPLETE);
    // }
  }

  async saveFormComplete() {
    // TODO: Se comenta, porque resetea los campos multiselect del vjsf al hacer el reload. Validar en caso de fallas
    // const formHasBeenReloaded = await this.reloadData();
    // if (formHasBeenReloaded) {
    await this.onSend(FORMS_CONSTANTS.STATE.COMPLETE);
    // }
  }

  async getFormTemplatePreviewData(id: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );

      if (response.code === Http.Found && response.data != null) {
        const responseData = response.data;

        this.schema = responseData.schema;
        this.formSummary = responseData.formSummary;
        this.formRules = responseData.formRules;
        this.model = Utils.initialModel(this.schema);
        this.partialSave = responseData.partialSave ?? false;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async reloadData(): Promise<boolean> {
    const items = this.schema.fields ? this.schema.fields : [];
    const conditions = this.schema.conditions ? this.schema.conditions : [];

    items.forEach(field => {
      if (
        field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA &&
        field.formula
      ) {
        this.formulaValue = field.formula.repeat(1);
        let fields = this.formulaValue.match(/\b[0-9A-Za-z_.-]{10}\b/g);

        if (fields !== null) {
          const uniqueSet = new Set(fields);
          fields = JSON.parse(JSON.stringify([...uniqueSet]));

          fields!.forEach(fieldString => {
            if (fieldString in this.model) {
              let newValue = "";
              let score;

              const existList = items.find(
                item =>
                  item.key === fieldString &&
                  item.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST
              );

              if (existList != undefined) {
                if (existList.options) {
                  score =
                    existList.options.find(
                      item => item.value === this.model[fieldString]
                    )?.score || 0;
                } else {
                  score =
                    existList.schema.oneOf?.find(
                      item => item.const === this.model[fieldString]
                    )?.score || 0;
                }
              }
              if ((score && Number(score)) || score == 0) {
                newValue = score.toString() || "";
              } else {
                newValue = this.model[fieldString] || "";
              }
              const regExp = new RegExp(fieldString, "g");
              this.formulaValue = this.formulaValue.replace(
                regExp,
                `${newValue}`
              );
            }
          });

          try {
            const result = eval(this.formulaValue);
            if (result && isFinite(result)) {
              Vue.set(this.model, field.key, result.toString());
              this.modelChanged = true;
            }
          } catch (e) {
            delete this.model[field.key];
          }
        }
      } else {
        // TODO: Se comenta, porque resetea los campos multiselect del vjsf al hacer el reload. Validar en caso de fallas
        // this.modelChanged = true;
      }
    });

    conditions.forEach(condition => {
      if (condition.isArray && this.model[condition.key] != undefined) {
        this.model[condition.key].sort();
        this.modelChanged = true;
      }
    });

    if (this.modelChanged) {
      this.refresh = 1 - this.refresh;
      this.modelChanged = false;
      return true;
    } else {
      return false;
    }
  }

  completeState() {
    this.$emit(FORMS_CONSTANTS.EVENTS.STATE_COMPLETE);
  }

  deleteTask() {
    this.$emit(
      TASK_CONSTANTS.EVENTS.DELETE,
      this.header.formTemplate.taskId,
      this.header.formTemplate.name
    );
  }

  assignedUser() {
    this.$emit(TASK_CONSTANTS.EVENTS.ASSIGN, this.header);
  }

  onModalClose() {
    this.dialog = false;
  }

  goToPatientProfile(patientId: string) {
    if (patientId != "") {
      localStorage.setItem(
        LOCAL_STORAGE.TASK_ID,
        this.header.formTemplate.taskId
      );
      this.$router.push(PROFILE_ROUTE + patientId);
    }
  }
}
